<script setup>
import { RouterLink } from 'vue-router';
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const { $stores } = proxy;

const userStore = $stores?.user;
const isLoggedIn = computed(
  () => userStore?.state?.isLoggedIn || !!userStore?.state?.current
);

const handleLogout = () => {
  proxy.$bus?.emit('user.logout');
};
</script>

<template>
  <footer
    v-show="!['/register', '/login'].includes($route.path)"
    style="background: #0a0a0b; border-top: 1px solid rgba(255, 255, 255, 0.06)"
  >
    <div class="max-w-screen-2xl mx-auto px-6 lg:px-8 py-16">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12">
        <!-- Logo & Description -->
        <div>
          <RouterLink to="/" class="flex items-center gap-3 mb-6">
            <img
              src="/kingrecharges-logo.svg"
              alt="Kingrecharges Store"
              class="w-12 h-12"
            />
            <div class="flex flex-col">
              <span
                class="font-bold text-xl text-white"
                style="font-family: 'Outfit', sans-serif"
                >LacasaeStore</span
              >
              <span class="text-xs text-white/50">Premium Store</span>
            </div>
          </RouterLink>
          <p class="text-sm text-white/60 leading-relaxed">
            Abonnements numériques premium à des tarifs imbattables.<br /><br />
            Netflix, Spotify, Apple TV, Disney+ et bien plus disponibles en
            quelques clics. Notre équipe vous accompagne 24h/24 et 7j/7 avec un
            service rapide, fiable et sécurisé.
          </p>
        </div>

        <!-- Réseaux Sociaux -->
        <div>
          <h3
            class="font-bold text-lg mb-6 text-white"
            style="font-family: 'Outfit', sans-serif"
          >
            Réseaux Sociaux
          </h3>
          <ul class="space-y-3">
            <li>
              <a
                href="#"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined" style="color: #37b6e9"
                  >photo_camera</span
                >
                <span>Instagram</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined" style="color: #37b6e9"
                  >thumb_up</span
                >
                <span>Facebook</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined" style="color: #37b6e9"
                  >play_circle</span
                >
                <span>YouTube</span>
              </a>
            </li>
          </ul>
        </div>

        <!-- Liens Utiles -->
        <div>
          <h3
            class="font-bold text-lg mb-6 text-white"
            style="font-family: 'Outfit', sans-serif"
          >
            Liens Utiles
          </h3>
          <ul class="space-y-3">
            <li>
              <RouterLink
                to="/"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg">home</span>
                <span>Accueil</span>
              </RouterLink>
            </li>
            <li>
              <RouterLink
                to="/boutique"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg"
                  >shopping_bag</span
                >
                <span>Boutique</span>
              </RouterLink>
            </li>
            <li>
              <RouterLink
                to="/cart"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg"
                  >shopping_cart</span
                >
                <span>Panier</span>
              </RouterLink>
            </li>
            <li v-if="isLoggedIn">
              <RouterLink
                to="/dashboard"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg">dashboard</span>
                <span>Mon Espace</span>
              </RouterLink>
            </li>
            <li v-if="!isLoggedIn">
              <RouterLink
                to="/login"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg">login</span>
                <span>Connexion</span>
              </RouterLink>
            </li>
            <li v-if="!isLoggedIn">
              <RouterLink
                to="/register"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg">person_add</span>
                <span>Inscription</span>
              </RouterLink>
            </li>
            <li v-if="isLoggedIn">
              <button
                @click="handleLogout"
                class="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <span class="material-icons-outlined text-lg">logout</span>
                <span>Déconnexion</span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="mt-16 pt-8 text-center"
        style="border-top: 1px solid rgba(255, 255, 255, 0.06)"
      >
        <p class="text-sm text-white/50">
          © 2026 Kingrecharges. Tous droits réservés. Développé pour vous par
          <a
            href="https://wa.me/22952282424"
            class="font-medium hover:underline"
            style="color: #4b4ced"
            >LACASAE GROUP</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>
